module.exports = __webpack_public_path__ + "static/media/subway-ticketmachine2.77f6a7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/structures/subway-ticketmachine2.png
// module id = 171
// module chunks = 0